import React, { useEffect } from 'react';
import { RBHBox, RBHButton, RBHText } from '../../components';
import styles from './styles';
import styleText from '../rbh-text/styles';
import styleButton from '../rbh-button/styles';
import { WarningOutlined } from '@ant-design/icons';

export const RBHError: React.FC<Props> = (p) => {

  useEffect(() => {

  }, []);

  const onOk = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    p.onOk();
  };

  return (
    <RBHBox style={styles.defaultContent}>
      <WarningOutlined id={'error-image'} data-testid={'error-image'} translate={null} style={styles.icon} />
      <RBHText data-testid={'id-error-title'} id={'id-error-title'} style={styleText.exceptionHeader} text={'main.systemnotavailable'} />
      <RBHText data-testid={'id-error-content'} id={'id-error-content'}
        style={{ ...styleText.exceptionContent, paddingBottom: 24 }} text={'main.retry'} />
      <RBHButton data-testid={'id-error-ok'} id={'id-error-ok'}
        onClick={onOk} style={styleButton.buttonModalCancelGradient} text={'main.button_ok'} />
    </RBHBox>
  );
};

type Props = {
  onOk?: any
};

export default RBHError;
